import { GA_USER_ID } from 'constants/user';

import ApiClientMobile from 'services/api/ApiClientMobile';

import { getCookie } from 'helpers/cookie';

import { IChannelDeeplinkResponse } from 'types/bigScreen';
import { DeepLinkData, HashedEmailResp, UserFeature } from 'types/apiInterfaces/user';
import {
    IUpdateUserProfileRequest,
    IUpdateUserProfileResponse,
    IUserPersonalisationRequest,
    IUserPersonalisationResponse,
    IUserProfileResponse,
} from './types';

class UserApi {
    getUser = async <Response = IUserProfileResponse>(): Promise<Partial<Response>> => {
        return await ApiClientMobile.get<Response>('user');
    };

    update = async <Data = IUpdateUserProfileRequest, Response = IUpdateUserProfileResponse>(
        payload: Data
    ): Promise<Partial<Response>> => {
        return await ApiClientMobile.patch<Data, Response>('user/', payload);
    };

    deepLinks = async <Response = DeepLinkData>(): Promise<Partial<Response>> => {
        return await ApiClientMobile.get<Response>('user/auth-deeplink');
    };

    getProducts = async () => {
        return await ApiClientMobile.get<HashedEmailResp>('/user/extra_purchases');
    };

    getFeatures = async () => {
        return await ApiClientMobile.get<{ features: UserFeature[] }>('/subscriptions/v1/user/features');
    };

    getChannelDeepLink = async <Response = IChannelDeeplinkResponse>(): Promise<Partial<Response>> => {
        return await ApiClientMobile.post<NonNullable<unknown>, Response>('user/big-screen/channel-deeplink', {});
    };

    postGoogleAnalyticsId = async () => {
        const gaId = getCookie(GA_USER_ID);

        return await ApiClientMobile.post<NonNullable<unknown>, Response>('/user/analytics', {
            'google-analytics-id': gaId,
        });
    };

    getUserPersonalisation = async <Response = IUserPersonalisationResponse>(): Promise<Partial<Response>> => {
        return await ApiClientMobile.get<Response>('user/personalisation');
    };

    putUserPersonalisation = async <Data = IUserPersonalisationRequest, Response = IUserPersonalisationResponse>(
        payload: Data
    ): Promise<Partial<Response>> => {
        return await ApiClientMobile.patch<Data, Response>('user/personalisation', payload);
    };

    getUserWebAnalytics = async <Response = IUserPersonalisationResponse>(): Promise<Partial<Response>> => {
        return await ApiClientMobile.get<Response>('user/web-analytics');
    };
}

export default UserApi;
